var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
var ModelPanel = /** @class */ (function (_super) {
    __extends(ModelPanel, _super);
    function ModelPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelPanel.prototype.onChange = function (event) {
        this.$emit('select', Number(event.target.value));
    };
    __decorate([
        Prop({ type: Array, required: true })
    ], ModelPanel.prototype, "models", void 0);
    __decorate([
        Prop({ type: Number, default: null })
    ], ModelPanel.prototype, "selectedModelId", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ModelPanel.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], ModelPanel.prototype, "aiModelsUrl", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], ModelPanel.prototype, "strings", void 0);
    ModelPanel = __decorate([
        Component
    ], ModelPanel);
    return ModelPanel;
}(Vue));
export default ModelPanel;
